// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OnboardingCustomizing_wrapper__3ApOF","container":"OnboardingCustomizing_container__8sfr4","logo":"OnboardingCustomizing_logo__1FcPP"};